"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default = /*#__PURE__*/function () {
  function _default() {
    var scripts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var retryLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    (0, _classCallCheck2.default)(this, _default);
    (0, _defineProperty2.default)(this, "scripts", void 0);
    (0, _defineProperty2.default)(this, "retryLimit", void 0);
    this.scripts = scripts;
    this.retryLimit = retryLimit;
  }

  (0, _createClass2.default)(_default, [{
    key: "get",
    value: function get(url) {
      return this.scripts[url];
    }
  }, {
    key: "set",
    value: function set(url, status) {
      this.scripts[url] = _objectSpread({
        url: url
      }, status);
      return this.get(url);
    }
  }, {
    key: "load",
    value: function load(url, type) {
      return new Promise(function (res) {
        var _document$getElements, _document$getElements2;

        var s = document.createElement('script');
        s.onload = res;
        s.type = type;
        s.src = url;
        (_document$getElements = document.getElementsByTagName('head')) === null || _document$getElements === void 0 ? void 0 : (_document$getElements2 = _document$getElements[0]) === null || _document$getElements2 === void 0 ? void 0 : _document$getElements2.appendChild(s);
      });
    }
  }, {
    key: "loadScript",
    value: function () {
      var _loadScript = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url) {
        var type,
            script,
            _args = arguments;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                type = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'text/javascript';
                script = this.get(url);

                if (!script) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", script);

              case 4:
                if (!document.querySelector("script[src=\"".concat(url, "\"]"))) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", this.set(url, {
                  loading: false,
                  loaded: true
                }));

              case 6:
                this.set(url, {
                  loading: true,
                  loaded: false
                });
                _context.next = 9;
                return this.load(url, type);

              case 9:
                return _context.abrupt("return", this.set(url, {
                  loading: false,
                  loaded: true
                }));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadScript(_x) {
        return _loadScript.apply(this, arguments);
      }

      return loadScript;
    }()
  }, {
    key: "loadComplete",
    value: function () {
      var _loadComplete = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(url) {
        var _this = this;

        var type,
            s,
            _args3 = arguments;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                type = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 'text/javascript';
                _context3.next = 3;
                return this.loadScript(url, type);

              case 3:
                s = _context3.sent;

                if (!(s === null || s === void 0 ? void 0 : s.loaded)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", s);

              case 6:
                return _context3.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                  var count = 0;
                  var t = setInterval( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
                    var ss;
                    return _regenerator.default.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!(count >= _this.retryLimit)) {
                              _context2.next = 4;
                              break;
                            }

                            clearInterval(t);
                            rej(new Error('Script load limit exceeded'));
                            return _context2.abrupt("return");

                          case 4:
                            _context2.next = 6;
                            return _this.loadScript(url, type);

                          case 6:
                            ss = _context2.sent;

                            if (ss === null || ss === void 0 ? void 0 : ss.loaded) {
                              clearInterval(t);
                              res(ss);
                            }

                            count++;

                          case 9:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  })), 100);
                })));

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadComplete(_x2) {
        return _loadComplete.apply(this, arguments);
      }

      return loadComplete;
    }()
  }]);
  return _default;
}();

exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/securedocuments-sdk-js/dist/utilities/ScriptManager/ScriptManager.js
// module id = 1853
// module chunks = 0